import /*React,*/ { useRef, useEffect, useState } from 'react';

// local dependencies
import { isOverflowing } from 'utils/dom';
import * as tooltipUtil from './tooltip.util';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { Tooltip } from 'modules/tooltip';
 *
 * // render
 * <TooltipView propName='propValue'/>
 */
export const tooltip = ( props ) => {
    
    // maintain active state
    const [ isActive, setActive ] = useState( props.active );

    /*------*/

    // DOM ref for the child element
    const ref = useRef();
    
    useEffect( () => {

        // set `isActive` to `true` if the child element is overflowing
        if( props.activateOnOverflow ) {
            setActive( isOverflowing( ref.current ) );
        }
    }, [ ref.current ] );

    /*------*/

    // return render prop with `ref` and event handlers
    return ! isActive ? props.render( {} ) : props.render( {
        ref,
        onMouseEnter: ( event ) => tooltipUtil.open( { element: event.currentTarget, title: props.title, text: props.text } ),
        onMouseLeave: () => tooltipUtil.close(),
        onClick: () => tooltipUtil.close(),
    } );
};

// set display name
tooltip.displayName = 'tooltip';

// set default props
tooltip.defaultProps = {
    active: true, // on/off trigger
    activateOnOverflow: false,
    title: undefined,
    text: undefined,
};

// prop types
tooltip.propTypes = {};
